import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

// roles:       array di ruoli
// redirect:    se true nel caso di non autenticato fa redirect a Login
//              (utile per rotte, false per parti di componenti da non mostrare)

export default function(roles, redirect = true) {

  const requiredRoles = roles || null;

  return function wrapWithRequiredAuth(WrappedComponent) {

    class Authentication extends Component {

      checkRequiredAuth(auth) {
        if (!auth.authenticated) {
          console.error('NOT AUTHENTICATED');
          return false;
        }
        if (requiredRoles && requiredRoles.indexOf(auth.user.role) === -1) {
          console.error('MISSING REQUIRED ROLE ' + requiredRoles.join(' or '));
          return false;
        }
        // OK, puoi passare :)
        return true
      }

      componentDidMount() {
        // REDIRECT
        if (redirect && !this.checkRequiredAuth(this.props)) {
          this.props.router.push('/');
        }
      }

      componentWillUpdate(nextProps) {
        // REDIRECT
        if (redirect && !this.checkRequiredAuth(nextProps)) {
          this.props.router.push('/');
        }
      }

      render() {
        // RENDER SE AUTENTICATO
        return this.checkRequiredAuth(this.props) ? <WrappedComponent {...this.props} /> : null;
      }
    }

    function mapStateToProps(state) {
      return {
        authenticated: state.user.authenticated,
        user: state.user.data
      };
    }

    return withRouter(connect(mapStateToProps)(Authentication));
  }
}
